/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Thu Aug 24 2023
 **/

import { useEffect, useRef } from "react";

import { Environments } from "@/frameworks/libraries/utilities";

interface TokenResponse {
	clientId: string;
	client_id: string;
	credential: string;
	select_by: string;
}

export default function useGoogleButton(events?: { onCredentialResponse: (token: TokenResponse) => void }) {
	const googleButton = useRef<HTMLDivElement>(null);

	const onload = () => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const googleAccount = window.google as any;
		googleAccount.accounts.id.initialize({
			client_id: Environments.env<string>("CLIENT_ID"),
			callback: events?.onCredentialResponse
		});
		googleAccount.accounts.id.renderButton(googleButton.current, {
			theme: "outline",
			size: "large",
			width: "288px",
			text: "signup_with"
		});
	};

	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://accounts.google.com/gsi/client";
		script.onload = onload;
		document.body.appendChild(script);

		return () => {
			document.body.removeChild(script);
		};
	}, []);

	return { googleButton };
}
